import { Modal } from "@common/Modal";
import i18n from "@service/locale/i18";

export const showErrorModal = async (text: string) => {
    const modal = new Modal({
        title: "Error",
        contentText: text,
        buttons: [
            {
                text: 'Ok',
                class: 'is-green is-middle',
                returnValue: true
            }
        ]
    });

    return await modal.showConfirm();
}

export const showNeedRightsModal = async () => {
    return await showErrorModal(i18n.t("common.needRightsError").toString());
}